export const featureNames = {}
const featureOptions = {}

//Enabled features (i.g We can disable/enable features using envs/client-params)
defineFeatureCircuitExecStepHighlightShowStartStopMarkers()

//Audit
export const featureFunctionIds = {
  geocoding: 409, //409    Recherche carto (MANUAL)
  mapRightClick: 407, //407    Menu carto (MANUAL) (trigger: right click on map)
  releaseNotes: 431, //431    Notes de version (MANUAL)
  predefinedViews: 412, //412    Vues prédéfinies (MANUAL) (trigger: feature is visible)
  locationRealtime: 356,
  locationHistory: 404,
  messages: 408,
  events: 365,
  locationCircuitTab: 367,
  identification: 364,
  alerts: 389,
}
defineFeature('enableAuditGeocoding')
defineFeature('enableAuditMapRightClick')
defineFeature('enableAuditReleaseNotes')
defineFeature('enableAuditPredefinedViews')
defineFeature('enableAuditLocationRealtime')
defineFeature('enableAuditLocationHistory')
defineFeature('enableAuditMessages')
defineFeature('enableAuditEvents')
defineFeature('enableAuditLocationCircuitTab')
defineFeature('enableAuditIdentification')
defineFeature('enableAuditAlerts')

function defineFeature(name, flag = true) {
  featureNames[name] = name
  featureOptions[name] = {
    validate() {
      return flag
    },
  }
}

/**
 * Used by CircuitRef / Location
 * Will display Stop/Start markers when the user highlight a circuit exec step.
 * A highlight overlay will be shown.
 */
function defineFeatureCircuitExecStepHighlightShowStartStopMarkers() {
  let name = 'CIRCUIT_EXEC_STEP_HIGHLIGHT_SHOW_START_STOP_MARKERS'
  featureNames[name] = name
  featureOptions[name] = {
    validate() {
      return true
    },
  }
}

export function hasFeature(featureName) {
  let options = featureOptions[featureName] || {}
  if (options.validate) {
    return options.validate()
  } else {
    return true
  }
}
